module.exports = __webpack_public_path__ + "img/arrows-select-black.c894c57a.svg";